module.exports = __webpack_public_path__ + "img/user-8.2af5fb0f.jpg";